import { lendingApiFetchJson } from 'lendingApi/lendingApi';
import { URLS } from 'utils/tests/urls.config';
import { TDeserialisedIntroducerFormData } from '../registration.types';

type TSubmitReferralForm = {
  values: TDeserialisedIntroducerFormData;
  onSuccess: () => void | Promise<void>;
  onError: () => void;
};

export const submitReferralRegistrationForm = async ({
  values,
  onSuccess,
  onError,
}: TSubmitReferralForm) => {
  const introducerValues = {
    title: values.title,
    first_name: values.firstName,
    last_name: values.lastName,
    email: values.email,
    phone_number: values.phoneNumber,
  };

  try {
    // Using lendingApiFetchJson as we need to send the FE tokens due to the user not being logged in
    await lendingApiFetchJson(URLS.postIntroducer(), {
      method: 'post',
      body: JSON.stringify({
        data: { ...introducerValues, introducer_company_id: values.uuid },
      }),
    });
    await onSuccess();
    return;
  } catch {
    onError();
  }
};
